import { useEffect, useRef, useCallback } from 'react';

export const useIdleTimeout = (
  logoutCallback: () => void,
  timeout: number = 10,
) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const resetTimer = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      logoutCallback();
    }, timeout);
  }, [logoutCallback, timeout]);

  useEffect(() => {
    const events = ['click', 'mousemove', 'mousedown', 'scroll', 'keypress'];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer]);

  return null;
};
